import kvaltynova from '../../../../../assets/images/members/kvaltynova.jpg';
import blaho from '../../../../../assets/images/members/blaho.jpg';
import sirlova from '../../../../../assets/images/members/sirlova.jpg';
import dvorakova from '../../../../../assets/images/members/dvorakova.jpg';

export { kvaltynova, blaho, sirlova, dvorakova };



// WEBPACK FOOTER //
// ./src/browser/Feature/components/team_member/photos.js